/*
	CSS
*/
require('../css/blocks.css');
require('../css/style-contact.css');
require('../css/style-content.css');
require('../css/style-dividers.css');
require('../css/style-footers.css');
require('../css/style-headers.css');
require('../css/style-portfolios.css');
require('../css/style-pricing.css');
require('../css/style-team.css');

/*
	scripts (as conventional globals)
*/
require("script!./vendor/jquery.min.js");
require("script!./flat-ui-pro.min.js");
require("script!./custom.js");


//////////////////
// WEBPACK FOOTER
// ./assets/original/js/_skeleton.js
// module id = 0
// module chunks = 7